import { render, staticRenderFns } from "./ItemCarouselWidget.vue?vue&type=template&id=1608c1bb&scoped=true"
import script from "./ItemCarouselWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemCarouselWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ItemCarouselWidget.vue?vue&type=style&index=0&id=1608c1bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608c1bb",
  null
  
)

export default component.exports